import { create } from "zustand";
import { IDLE_CONFIG } from "../config/IdleConfig";
import { globalLogout } from "../helpers/api_helper";

export const useIdleStore = create((set, get) => ({
  showIdlePopup: false,
  isIdle: false,
  lastActivity: Date.now(),
  countdown: IDLE_CONFIG.COUNTDOWN_SECONDS,
  countdownInterval: null,
  idlePopupEndTime: null, // timestamp when popup should auto-logout
  setActivity: () => {
    if (get().showIdlePopup) return;
    set({
      lastActivity: Date.now(),
      isIdle: false,
    });
    // Broadcast popup close to all tabs
    localStorage.setItem("idle_popup_visible", "false");
  },
  markIdle: () => set({ isIdle: true }),
  showPopup: () => {
    // Auth guard: Only show popup if user is logged in
    const isAuthenticated = !!(
      localStorage.getItem("Token") ||
      localStorage.getItem("access_token")
    );
    if (!isAuthenticated) return;
    if (get().showIdlePopup) return;
    // Calculate end time and store in localStorage for cross-tab sync
    const endTime = Date.now() + IDLE_CONFIG.COUNTDOWN_SECONDS * 1000;
    set({
      showIdlePopup: true,
      countdown: IDLE_CONFIG.COUNTDOWN_SECONDS,
      idlePopupEndTime: endTime,
    });
    localStorage.setItem("idle_popup_visible", "true");
    localStorage.setItem("idle_popup_end_time", endTime.toString());
    // Start interval to update countdown based on end time
    const interval = setInterval(() => {
      const { idlePopupEndTime } = get();
      const now = Date.now();
      const secondsLeft = Math.max(0, Math.ceil((idlePopupEndTime - now) / 1000));
      set({ countdown: secondsLeft });
      if (secondsLeft <= 0) {
        clearInterval(interval);
        get().logout();
      }
    }, 1000);
    set({ countdownInterval: interval });
  },
  resetIdle: () => {
    const interval = get().countdownInterval;
    if (interval) clearInterval(interval);
    set({
      showIdlePopup: false,
      isIdle: false,
      countdown: IDLE_CONFIG.COUNTDOWN_SECONDS,
      countdownInterval: null,
      lastActivity: Date.now(),
      idlePopupEndTime: null,
    });
    // Broadcast popup close to all tabs
    localStorage.setItem("idle_popup_visible", "false");
    localStorage.removeItem("idle_popup_end_time");
  },
  logout: () => {
    const interval = get().countdownInterval;
    if (interval) clearInterval(interval);
    globalLogout();
  },
}));
